module.exports = ($templateCache) ->
  scope:
    metadata:        "=metadataContent"
    metadataClass: "@metadataContentClass"

  link: () ->
    $templateCache.put(
      "metadata-content",
      require("./metadata-content.tpl.html")
    )

  controller: "MetadataContentController"

  template: require("./metadata-content.html")
